import { Navigate, useLocation } from 'react-router-dom';
import { getAuthToken, REDIRECT_AFTER_LOGIN_KEY } from '@/lib/auth';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const token = getAuthToken();
  if (!token) {
    try {
      window.localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, location.pathname + location.search);
    } catch {
      /* storage blocked */
    }
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
